// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import axios from 'axios'
import VueAuth from '@websanova/vue-auth'
import VuejsDialog from 'vuejs-dialog'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import store from './vuex/store'
import moment from 'moment'
import VeeValidate from 'vee-validate'
import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

// import '../static/js/daterangepicker.min'
import Index from './components/views/Index'
// import Dashboard from './components/views/Dashboard'
import Monitoramento from './components/views/Monitoramento'
// import MonitoramentoTeste from './components/views/Monitoramento'
// import MonitoramentoTeste2 from './components/views/MonitoramentoTeste2'
import Grid from './components/views/Grid'
import Dashboard from './components/views/Dashboard'
import Relatorios from './components/views/Relatorios'
import RelatoriosTelemetria from './components/views/RelatoriosTelemetria'

import AnaliseJornadas from './components/views/jornadas/AnaliseJornadas'
import AnaliseJornadasView from './components/views/jornadas/AnaliseJornadasView'
import GestaoJornadasLista from './components/views/jornadas/GestaoJornadasLista'
import GestaoJornadasNovo from './components/views/jornadas/GestaoJornadasNovo'
import GestaoJornadasEditar from './components/views/jornadas/GestaoJornadasEditar'

import AnaliseJornadasTabela from './components/views/jornadastabelas/AnaliseJornadaTabela'
import AnaliseJornadasTabelaEditar from './components/views/jornadastabelas/AnaliseJornadaTabelaEditar'
import AnaliseJornadasTabelaVisualizar from './components/views/jornadastabelas/AnaliseJornadaTabelaVisualizar'

import AnaliseJornadasConvencao from './components/views/jornadasconvencoes/AnaliseJornadasConvencao'
import AnaliseJornadasConvencaoView from './components/views/jornadasconvencoes/AnaliseJornadasConvencaoView'
import GestaoJornadasConvencaoLista from './components/views/jornadasconvencoes/GestaoJornadasConvencaoLista'
import GestaoJornadasConvencaoNovo from './components/views/jornadasconvencoes/GestaoJornadasConvencaoNovo'
import GestaoJornadasConvencaoEditar from './components/views/jornadasconvencoes/GestaoJornadasConvencaoEditar'

import Agenda from './components/views/agenda/Agenda'
import Login from './components/views/Login'
import Logout from './components/views/Logout'
import ClientesLista from './components/views/clientes/ClientesLista'
import ClientesEditar from './components/views/clientes/ClientesEditar'
import MotoristasLista from './components/views/motoristas/MotoristasLista'
import MotoristasEditar from './components/views/motoristas/MotoristasEditar'
import VeiculosLista from './components/views/veiculos/VeiculosLista'
import VeiculosEditar from './components/views/veiculos/VeiculosEditar'
import AreasLista from './components/views/areas/AreasLista'
import AreasEditar from './components/views/areas/AreasEditar'
import PontosLista from './components/views/pontos/PontosLista'
import PontosEditar from './components/views/pontos/PontosEditar'
import ConvencoesLista from './components/views/convencoes/ConvencoesLista'
import ConvencoesEditar from './components/views/convencoes/ConvencoesEditar'
import EventosLista from './components/views/eventos/EventosLista'
import EventosEditar from './components/views/eventos/EventosEditar'
import EventosDisparadosLista from './components/views/eventosdisparados/EventosDisparadosLista'
import UsuariosLista from './components/views/usuarios/UsuariosLista'
import UsuariosEditar from './components/views/usuarios/UsuariosEditar'
import RelatorioDePosicoesView from './components/views/relatorios/RelatorioDePosicoesView'
import RelatorioDePosicoesNovoView from './components/views/relatorios/RelatorioDePosicoesNovoView'
import RelatorioDePosicoesObdView from './components/views/relatorios/RelatorioDePosicoesObdView'
import RelatorioDePosicoesObdTripView from './components/views/relatorios/RelatorioDePosicoesObdTripView'
import RelatorioDeAnaliseTrabalhoProducaoView from './components/views/relatorios/RelatorioDeAnaliseTrabalhoProducaoView'
import RelatorioDeAnaliseDeCondutaView from './components/views/relatorios/RelatorioDeAnaliseDeCondutaView'
import RelatorioDeAnaliseTrabalhoProducaoSinteticoView from './components/views/relatorios/RelatorioDeAnaliseTrabalhoProducaoSinteticoView'
import RelatorioDeAcionamentoDeEntradaView from './components/views/relatorios/RelatorioDeAcionamentoDeEntradaView'
import RelatorioDeAcionamentoDeEntradaSinteticoView from './components/views/relatorios/RelatorioDeAcionamentoDeEntradaSinteticoView'
import RelatorioDeTempoForaHorarioTrabalhoView from './components/views/relatorios/RelatorioDeTempoForaHorarioTrabalhoView'
import RelatorioDeKmRodadoVeiculoView from './components/views/relatorios/RelatorioDeKmRodadoVeiculoView'
import RelatorioDeKmRodadoFrotaView from './components/views/relatorios/RelatorioDeKmRodadoFrotaView'
import RelatorioTelemetriaViagemGeralView from './components/views/relatoriosTelemetria/RelatorioTelemetriaViagemGeralView'
import RelatorioTelemetriaViagemPorVeiculoView from './components/views/relatoriosTelemetria/RelatorioTelemetriaViagemPorVeiculoView'
import RelatorioTelemetriaViagemPorMotoristaView from './components/views/relatoriosTelemetria/RelatorioTelemetriaViagemPorMotoristaView'
import NotFoundView from './components/views/NotFoundView'
// import VendasVisualizar from './components/views/vendas/VendasVisualizar'
// Vue.config.productionTip = false
// Vue.http.options.credentials = true
// Vue.http.headers.common['Access-Control-Allow-Origin'] = true
// Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
// Vue.http.headers.common['Access-Control-Allow-Credentials'] = '*'
// Vue.http.headers.common['Authorization'] = 'Basic ZGV2ZWxvcGVyOnRlc3RlMTIz'
/* eslint-disable no-new */
import SparkPlugin from './components/spark-components/spark-components-plugin'
// import VueMultianalytics from 'vue-multianalytics'
import VTooltip from 'v-tooltip'
import * as VueGoogleMaps from 'vue2-google-maps'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import JsonExcel from 'vue-json-excel'

Vue.use(SparkPlugin)
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VuejsDialog)
Vue.use(BootstrapVue)
Vue.use(VeeValidate)
Vue.use(VTooltip)
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 2000
})
Vue.use(VueSidebarMenu)
Vue.use(DatePicker)
Vue.component('downloadExcel', JsonExcel)

Vue.axios = axios
// const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
//   baseUrl: 'http://localhost:9090'
// })
const router = new VueRouter({
  hashbang: false,
  linkActiveClass: 'active',
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/login', name: 'Login', component: Login, meta: {auth: false} },
    { path: '/logout', name: 'Logout', component: Logout, meta: {auth: false} },
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {auth: true},
      children: [
        { path: 'grid', alias: '', name: 'account', component: Grid, meta: {auth: true, analytics: 'account'} },
        { path: 'grid', alias: '', name: 'Grid', component: Grid, meta: {auth: true, analytics: 'Grid'} },
        { path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: {auth: true, analytics: 'Dashboard'} },
        { path: '/monitoramento', name: 'Monitoramento', component: Monitoramento, meta: {auth: true, analytics: 'Monitoramento'} },
        { path: '/relatorios', name: 'Relatorios', component: Relatorios, meta: {auth: true, analytics: 'Relatorios'} },
        { path: '/relatoriosTelemetria', name: 'RelatoriosTelemetria', component: RelatoriosTelemetria, meta: {auth: true, analytics: 'RelatoriosTelemetria'} },
        { path: '/agenda', name: 'Agenda', component: Agenda, meta: {auth: true, analytics: 'Agenda'} },
        { path: '/clientes', name: 'ClientesLista', component: ClientesLista, meta: {auth: true, analytics: 'ClientesLista'} },
        { path: '/clientes/editar/:id', name: 'ClientesEditar', component: ClientesEditar, meta: {auth: true, analytics: 'ClientesEditar'} },
        { path: '/motoristas', name: 'MotoristasLista', component: MotoristasLista, meta: {auth: true} },
        { path: '/motoristas/editar/:id', name: 'MotoristasEditar', component: MotoristasEditar, meta: {auth: true} },
        { path: '/veiculos', name: 'VeiculosLista', component: VeiculosLista, meta: {auth: true} },
        { path: '/veiculos/editar/:id', name: 'VeiculosEditar', component: VeiculosEditar, meta: {auth: true} },
        { path: '/usuarios', name: 'UsuariosLista', component: UsuariosLista, meta: {auth: true} },
        { path: '/usuarios/editar/:id', name: 'UsuariosEditar', component: UsuariosEditar, meta: {auth: true} },
        { path: '/analiseJornada', name: 'AnaliseJornadas', component: AnaliseJornadas, meta: {auth: true} },
        { path: '/analiseJornadaView/:veiculo/:dataInicial/:dataFinal', name: 'AnaliseJornadasView', component: AnaliseJornadasView, meta: {auth: true} },
        { path: '/gestaoJornada', name: 'GestaoJornadasLista', component: GestaoJornadasLista, meta: {auth: true} },
        { path: '/gestaoJornada/novo', name: 'GestaoJornadasNovo', component: GestaoJornadasNovo, meta: { auth: true } },
        { path: '/gestaoJornada/editar/:id', name: 'GestaoJornadasEditar', component: GestaoJornadasEditar, meta: { auth: true } },

        { path: '/analiseJornadaTabela', name: 'AnaliseJornadasTabela', component: AnaliseJornadasTabela, meta: {auth: true} },
        { path: '/analiseJornadaTabelaEditar', name: 'AnaliseJornadasTabelaEditar', component: AnaliseJornadasTabelaEditar, meta: {auth: true} },
        { path: '/analiseJornadasTabelaVisualizar', name: 'AnaliseJornadasTabelaVisualizar', component: AnaliseJornadasTabelaVisualizar, meta: {auth: true} },

        { path: '/analiseJornadaConvencao', name: 'AnaliseJornadasConvencao', component: AnaliseJornadasConvencao, meta: {auth: true} },
        { path: '/analiseJornadaConvencaoView/:veiculo/:dataInicial/:dataFinal', name: 'AnaliseJornadasConvencaoView', component: AnaliseJornadasConvencaoView, meta: {auth: true} },
        { path: '/gestaoJornadaConvencao', name: 'GestaoJornadasConvencaoLista', component: GestaoJornadasConvencaoLista, meta: {auth: true} },
        { path: '/gestaoJornadaConvencao/novo', name: 'GestaoJornadasConvencaoNovo', component: GestaoJornadasConvencaoNovo, meta: { auth: true } },
        { path: '/gestaoJornadaConvencao/editar/:id', name: 'GestaoJornadasConvencaoEditar', component: GestaoJornadasConvencaoEditar, meta: { auth: true } },

        { path: '/eventos', name: 'EventosLista', component: EventosLista, meta: {auth: true} },
        { path: '/eventos/editar/:id', name: 'EventosEditar', component: EventosEditar, meta: { auth: true } },
        { path: '/eventosDisparados', name: 'EventosDisparadosLista', component: EventosDisparadosLista, meta: {auth: true} },
        { path: '/areas', name: 'AreasLista', component: AreasLista, meta: {auth: true} },
        { path: '/areas/editar/:id', name: 'AreasEditar', component: AreasEditar, meta: { auth: true } },
        { path: '/pontos', name: 'PontosLista', component: PontosLista, meta: {auth: true} },
        { path: '/pontos/editar/:id', name: 'PontosEditar', component: PontosEditar, meta: { auth: true } },
        { path: '/convencoes', name: 'ConvencoesLista', component: ConvencoesLista, meta: {auth: true} },
        { path: '/convencoes/editar/:id', name: 'ConvencoesEditar', component: ConvencoesEditar, meta: { auth: true } },

        { path: '/relatorioDePosicoesView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:agruparPosicoes', name: 'RelatorioDePosicoesView', component: RelatorioDePosicoesView, meta: {auth: true} },
        { path: '/relatorioDePosicoesNovoView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:agruparPosicoes', name: 'RelatorioDePosicoesNovoView', component: RelatorioDePosicoesNovoView, meta: {auth: true} },
        { path: '/relatorioDePosicoesObdView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:agruparPosicoes/:obdIgnicao/:obdRpm/:obdTemperatura/:obdErro', name: 'RelatorioDePosicoesObdView', component: RelatorioDePosicoesObdView, meta: {auth: true} },
        { path: '/relatorioDePosicoesObdTripView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:agruparPosicoes/:obdIgnicao/:obdRpm/:obdTemperatura/:obdErro', name: 'RelatorioDePosicoesObdTripView', component: RelatorioDePosicoesObdTripView, meta: {auth: true} },
        { path: '/relatorioDeAnaliseTrabalhoProducaoView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:entrada/:entradaVelocidade', name: 'RelatorioDeAnaliseTrabalhoProducaoView', component: RelatorioDeAnaliseTrabalhoProducaoView, meta: {auth: true} },
        { path: '/relatorioDeAnaliseTrabalhoProducaoSinteticoView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:entrada/:entradaVelocidade', name: 'RelatorioDeAnaliseTrabalhoProducaoSinteticoView', component: RelatorioDeAnaliseTrabalhoProducaoSinteticoView, meta: {auth: true} },
        { path: '/relatorioDeAnaliseDeCondutaView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade', name: 'RelatorioDeAnaliseDeCondutaView', component: RelatorioDeAnaliseDeCondutaView, meta: {auth: true} },
        { path: '/relatorioDeAcionamentoDeEntradaView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidadeMinima/:filtroVelocidadeMaxima/:desprezarVelocidade/:entrada', name: 'RelatorioDeAcionamentoDeEntradaView', component: RelatorioDeAcionamentoDeEntradaView, meta: {auth: true} },
        { path: '/relatorioDeAcionamentoDeEntradaSinteticoView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:entrada', name: 'RelatorioDeAcionamentoDeEntradaSinteticoView', component: RelatorioDeAcionamentoDeEntradaSinteticoView, meta: {auth: true} },
        { path: '/relatorioDeTempoForaHorarioTrabalhoView/:clienteId/:dataHoraInicial', name: 'RelatorioDeTempoForaHorarioTrabalhoView', component: RelatorioDeTempoForaHorarioTrabalhoView, meta: {auth: true} },

        { path: '/relatorioDeKmRodadoVeiculoView/:veiculoId/:dataHoraInicial/:dataHoraFinal', name: 'RelatorioDeKmRodadoVeiculoView', component: RelatorioDeKmRodadoVeiculoView, meta: {auth: true} },
        { path: '/relatorioDeKmRodadoFrotaView/:clienteId/:dataHoraInicial/:dataHoraFinal', name: 'RelatorioDeKmRodadoFrotaView', component: RelatorioDeKmRodadoFrotaView, meta: {auth: true} },
        { path: '/relatorioTelemetriaViagemGeralView/:veiculoId/:dataHoraInicial/:dataHoraFinal', name: 'RelatorioTelemetriaViagemGeralView', component: RelatorioTelemetriaViagemGeralView, meta: {auth: true} },
        { path: '/relatorioTelemetriaViagemPorVeiculoView/:veiculoId/:dataHoraInicial/:dataHoraFinal', name: 'RelatorioTelemetriaViagemPorVeiculoView', component: RelatorioTelemetriaViagemPorVeiculoView, meta: {auth: true} },
        { path: '/relatorioTelemetriaViagemPorMotoristaView/:motoristaId/:dataHoraInicial/:dataHoraFinal', name: 'RelatorioTelemetriaViagemPorMotoristaView', component: RelatorioTelemetriaViagemPorMotoristaView, meta: {auth: true} }
      ]
    }, {
      // not found handler
      path: '*',
      component: NotFoundView
    }
  ]
})
Vue.router = router
//
// Vue.axios.defaults.baseURL = 'http://localhost:8080'
Vue.axios.defaults.baseURL = 'http://site.colge.com.br'
//
//
Vue.use(VueGoogleMaps, {
  load: {
    // key: 'AIzaSyCNdW9zNp4aaHrlBIX8r7YnB3Axv4kvDv0',
    key: 'AIzaSyBB8zpoVYyi09wzrxZONTbJn-AkxOto3JM',
    libraries: 'places' // necessary for places input
  }
})

Vue.use(VueAuth, {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'roles',
  loginData: {url: '/login', method: 'POST', redirect: '/', fetchUser: true},
  fetchData: {url: '/loginData', method: 'GET', enabled: true},
  refreshData: {url: '/login', method: 'POST', enabled: false, interval: 0},
  parseUserData: function (data) {
    console.log('USER')
    console.log(data)
    return data.data
  }
})
Vue.use(require('vue-shortkey'))
Vue.http.interceptors.push(function (request, next) {
  next(function (res) {
    // Unauthorized Access
    if (res.status === 401 && ['UnauthorizedAccess', 'InvliadToken'].indexOf(res.data.code) > -1) {
      Vue.auth.logout({
        redirect: {name: 'Login'}
      })
    } else if (res.status === 500) {
      // System Error
      // Redirect to 500 page
    }
  })
})

Vue.mixin({
  methods: {
    limparQuantidade (value) {
      let val = ''
      if (isNaN(value)) {
        val = value.replace(',', '.')
        val = parseFloat((val / 1).toFixed(2))
      } else {
        val = parseFloat((value / 1).toFixed(2))
      }
      return val
    },
    limparQuantidade10 (value) {
      let val = ''
      if (isNaN(value)) {
        val = value.replace(',', '.')
        val = parseFloat((val / 1).toFixed(10))
      } else {
        val = parseFloat((value / 1).toFixed(10))
      }
      return val
    },
    limparPercentual (value) {
      let val = ''
      if (isNaN(value)) {
        val = value.replace(',', '.')
        val = parseFloat((val / 1).toFixed(2))
      } else {
        val = parseFloat((value / 1).toFixed(2))
      }
      return val
    },
    limparMonetario (value) {
      let val = ''
      if (isNaN(value)) {
        val = value.replace('R$ ', '').replace(',', '.')
        val = parseFloat((val / 1).toFixed(2))
      } else {
        val = parseFloat((value / 1).toFixed(2))
      }
      return val
    },
    limparMonetario10 (value) {
      let val = ''
      if (isNaN(value)) {
        val = value.replace('R$ ', '').replace(',', '.')
        val = parseFloat((val / 1).toFixed(10))
      } else {
        val = parseFloat((value / 1).toFixed(10))
      }
      return val
    },
    formatarMonetario (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatarPercentual (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return '' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatarVelocidade (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return '' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatarVelocidadeMetros (value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return '' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    primeiroDiaMes (mes) {
      if (mes === '') {
        let mes_ = (moment().months() + 1) + ''
        if (mes_.length === 1) {
          mes_ = '0' + mes_
        }
        return '01/' + (mes_) + '/' + moment().year()
      }
    },
    ultimoDiaMes (mes) {
      if (mes === '') {
        let mes_ = (moment().months() + 1) + ''
        if (mes_.length === 1) {
          mes_ = '0' + mes_
        }
        return moment().daysInMonth() + '/' + (mes_) + '/' + moment().year()
      }
    },
    dataAtual () {
      let dia_ = moment().date() + ''
      if (dia_.length === 1) {
        dia_ = '0' + dia_
      }
      let mes_ = (moment().months() + 1) + ''
      if (mes_.length === 1) {
        mes_ = '0' + mes_
      }
      return (dia_) + '/' + (mes_) + '/' + moment().year()
    },
    dataOntem () {
      let dataOntem = moment().subtract(1, 'days')
      let dia_ = dataOntem.date() + ''
      if (dia_.length === 1) {
        dia_ = '0' + dia_
      }
      let mes_ = (dataOntem.months() + 1) + ''
      if (mes_.length === 1) {
        mes_ = '0' + mes_
      }
      return (dia_) + '/' + (mes_) + '/' + dataOntem.year()
    },
    dataHoraAtual () {
      let dia_ = moment().date() + ''
      if (dia_.length === 1) {
        dia_ = '0' + dia_
      }
      let mes_ = (moment().months() + 1) + ''
      if (mes_.length === 1) {
        mes_ = '0' + mes_
      }
      return (dia_) + '/' + (mes_) + '/' + moment().year() + ' ' + moment().hours() + ':' + moment().minutes() + ':' + moment().seconds()
    },
    dataAtualAdicionar (data, tipo, quantidade) {
      let novaData = moment(data, 'DD/MM/YYYY')
      if (tipo === 'D') {
        novaData = novaData.add(quantidade, 'days')
      } else {
        novaData = novaData.add(quantidade, 'M')
      }
      let dia_ = novaData.date() + ''
      if (dia_.length === 1) {
        dia_ = '0' + dia_
      }
      let mes_ = (novaData.months() + 1) + ''
      if (mes_.length === 1) {
        mes_ = '0' + mes_
      }
      return (dia_) + '/' + (mes_) + '/' + novaData.year()
    },
    diasEntreDadas (dataInicial, dataFinal) {
      let dataInicial_ = moment(dataInicial, 'DD/MM/YYYY')
      let dataFinal_ = moment(dataFinal, 'DD/MM/YYYY')
      let duration = moment.duration(dataFinal_.diff(dataInicial_))
      let days = duration.asDays()
      if (isNaN(days)) {
        days = 0
      }
      return days
    },
    dataMenor (dataUm, dataDois) {
      let dataUm_ = moment(dataUm, 'DD/MM/YYYY')
      let dataDois_ = moment(dataDois, 'DD/MM/YYYY')
      return dataUm_.isBefore(dataDois_)
    },
    gerarCodigoBarras (numero) {
      let factor = 3
      let sum = 0
      for (var index = 0; numero.length < 12; index++) {
        numero = '0' + numero
      }
      for (index = numero.length; index > 0; --index) {
        sum = sum + numero.substring(index - 1, index) * factor
        factor = 4 - factor
      }
      let cc = ((1000 - sum) % 10)
      let digito = cc
      return numero + '' + digito
    },
    consultarOperadora (numero) {
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/consutarOperadora?celular=' + numero
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        return response.data
      })
    }
  }
})
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  store
})
// Vue.http.options.root = 'https://localhost:9090'
// Vue.axios.defaults.baseURL = 'https://localhost:9090'
// new Vue({
//   el: '#app',
//   router,
//   template: '<App/>',
//   components: { App }
// })



// WEBPACK FOOTER //
// ./src/main.js